{
  "longPressMessage": "Tieni premuto per aprire l’anteprima"
}
